import { profile, axiosConfig } from 'api';

import { BranchCompany } from 'models/branchCompany';
import { Response } from 'models/response';

export const getAllBranchesCompany = async (companyId: string): Promise<BranchCompany[]> => {
  try {
    const response = await profile.get<Response<BranchCompany[]>>(
      `/Company/GetAllBranchesCompany/${companyId}`,
      axiosConfig,
    );
    return response.data.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
